<template>
  <header id="header-top" class="module-top" v-if="showTop && !inMinProgram">
    <div class="module-top-left">
      <div class="iconfont icon-fanhui" @click="back"></div>
      <div class="iconfont icon-shouyexian" @click="goHome" v-if="home"></div>
    </div>
    <div class="module-top-title">{{ title | slice }}</div>
    <div class="module-top-right">
      <slot name="right"></slot>
    </div>
  </header>
</template>
<script>
import jsCookie from 'js-cookie'
export default {
  async mounted() {
    //            setTimeout(() => this.$$box.alert(document.cookie), 1000);
    const $top = document.querySelector('#header-top')
    if (!$top || !this.opacity) return
    window.addEventListener(
      'scroll',
      () => {
        const opacity = 20 / (window.scrollY || document.body.scrollTop)
        $top.style.opacity = opacity > 0.2 ? opacity : 0
      },
      false
    )
  },
  props: {
    title: {
      type: String,
      default: '加载中'
    },
    opacity: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    },
    home: {
      type: Boolean,
      default: true
    },
    evtBack: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    slice(val) {
      return val.length > 12 ? `${val.slice(0, 12)}...` : val
    }
  },
  methods: {
    back() {
      this.$emit('back')
      if (this.evtBack) {
        return
      }
      this.$router.back()
    },
    goHome() {
      this.$router.push('/home')
    }
  },
  computed: {
    inMinProgram() {
      return this.$store.state.inMinProgram
    },
    showTop() {
      // const isMinProgram = this.$$isMiniProgram()
      // if (this.inMinProgram) return false
      // if (jsCookie('miniprogramid') === 'wx38c03f55ea0ab651') {
      //     return false
      // }
      if (this.show) return this.show
      //                const hzw = this.$$queryString.parse(location.search).hzw || '';
      return !['android', 'ios'].filter(device => this.$$getDevice() === device)
        .length
    }
  }
}
</script>
<style lang="scss" scoped rel="stylesheet/scss">
@import '~assets/css/mixin.scss';
.module-top {
  display: flex;
  border-bottom: 1px solid #ddd;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: rem(88px);
  padding: 0 rem(20px);
  top: 0;
  left: 0;
  z-index: 201;
  background: #fff;
  font-size: rem(36px);
}
.module-top-left {
  display: flex;
  align-items: center;
  width: rem(100px);

  .iconfont {
    padding: rem(10px);
  }
  .icon-fanhui {
    display: inline-block;
    width: 0.3rem;
    height: 0.4rem;
    background-image: url('~@/assets/images/icon_arr_l@3x.png');
    background-size: contain;
  }
}
.module-top-title {
  font-size: rem(36px);
  color: #121212;
}
.module-top-right {
  width: rem(100px);
}
</style>
